<template>
  <header class="rin-header rin-header--mobile no-print">
    <div
      class="title-bar"
      :class="isPartnerShop"
      data-hide-for="xlarge"
      data-responsive-toggle="mobile-menu">
      <div class="grid-x top-menu-container">
        <div class="cell large-12">
          <ul class="menu mobtop-center">
            <li>
              <button
                class="menu-icon"
                data-toggle="mobile-menu"
                type="button"></button>
            </li>
            <li v-if="!partnerStatus">
              <a :href="vueHeader.loginLink">
                <img
                  :alt="vueHeader.loginAlt"
                  :src="icons.humanIcon" />
              </a>
            </li>
            <li v-if="partnerStatus">
              <a :href="vueHeader.dashboardUrl">
                <img
                  alt="Dashboard"
                  class="dashboardIcon"
                  :src="icons.dashboard" />
              </a>
            </li>
            <li class="menu-logo">
              <a href="/">
                <img
                  v-if="!isPartnerShop"
                  :alt="vueHeader.ringanaLogoAlt"
                  :src="vueHeader.headerLogoUrl" />
                <img
                  v-if="isPartnerShop"
                  :alt="vueHeader.ringanaLogoAlt"
                  :src="vueHeader.headerLogoUrlPartner" />
              </a>
            </li>
            <li class="menu-search">
              <span
                class="menu-search__search-icon"
                @click="toggleSearchbox">
                <img
                  :alt="vueHeader.searchAlt"
                  class="menu-search__image"
                  :src="icons.searchIcon" />
              </span>
            </li>
            <li class="menu-cart">
              <a :href="vueHeader.shopCartLink">
                <img
                  :alt="vueHeader.cartAlt"
                  class="cartIcon"
                  :src="icons.cartIcon" />
                <span class="basket-item-count">
                  <span class="value"></span>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="title-bar-title"></div>
      <ul
        id="mobile-menu"
        class="vertical menu this-hidden"
        data-multi-open="false"
        data-responsive-menu="accordion medium-accordion"
        style="max-width: 680px;">
        <li class="mobile-menu-nav-bar">
          <span class="back this-hidden">{{ vueHeader.backText }}</span>
          <img
            :alt="vueHeader.backIconAlt"
            class="mobile-menu-nav"
            :src="icons.closeIcon" />
        </li>
        <li
          v-if="!loggedIn"
          class="mobile-menu-login text-transform-uppercase"
          v-html="vueHeader.loginHtml"></li>
        <li
          v-if="loggedIn"
          class="mobile-menu-customer text-transform-uppercase">
          <a href="#">{{ loggedInName(user) }}</a>
          <!--customer menu-->
          <ul
            v-if="!partnerStatus"
            class="vertical menu">
            <li
              class="category"
              v-html="vueHeader.myAccount.data.titleDOM"></li>
            <li
              class="category"
              v-html="vueHeader.myAccount.orders.titleDOM"></li>
            <li
              class="category"
              v-html="vueHeader.myAccount.account.titleDOM"></li>
            <li
              v-if="isPartnerShop"
              class="category mobile-menu-partnershop">
              <a :href="freshPartnerURL">{{ vueHeader.freshPartnerText }}</a>
            </li>
            <li class="category">
              <span
                class="logout"
                @click.prevent="logout">{{ vueHeader.logout }}</span>
            </li>
          </ul>
          <ul
            v-if="partnerStatus"
            class="vertical menu">
            <li
              class="category"
              v-html="prepareMobileMenuAcademyDOM(vueHeader.myAccountPartner.academy.titleDOM, vueHeader.myAccountPartner.academy.entries)"></li>

            <li
              class="category"
              v-html="vueHeader.myAccountPartner.data.titleDOM"></li>
            <li
              class="category"
              v-html="vueHeader.myAccountPartner.orders.titleDOM"></li>
            <li
              class="category"
              v-html="vueHeader.myAccountPartner.account.titleDOM"></li>
            <li
              class="category"
              v-html="vueHeader.myAccountPartner.team.titleDOM"></li>
            <li
              class="category"
              v-html="vueHeader.myAccountPartner.partnerpage.titleDOM"></li>
            <li
              class="category"
              v-html="vueHeader.myAccountPartner.dates.titleDOM"></li>
            <li
              class="category"
              v-html="prepareMobileMenuDOM(vueHeader.myAccountPartner.statistics.titleDOM, vueHeader.myAccountPartner.statistics.entries)"></li>

            <li
              v-if="isPartnerShop"
              class="category mobile-menu-partnershop">
              <a :href="freshPartnerURL">{{ vueHeader.freshPartnerText }}</a>
            </li>
            <li class="category">
              <span
                class="logout"
                @click.prevent="logout">{{ vueHeader.logout }}</span>
            </li>
          </ul>
        </li>
        <li>
          <a
            class="text-transform-uppercase"
            href="#">{{ vueHeader.shopText }}</a>
          <ul class="vertical menu text-transform-uppercase">
            <li
              class="category"
              v-html="prepareMobileMenuDOM(vueHeader.shop.fresh.titleDOM, vueHeader.shop.fresh.entries)"></li>
            <li
              class="category"
              v-html="prepareMobileMenuDOM(vueHeader.shop.complete.titleDOM, vueHeader.shop.complete.entries)"></li>
            <li
              class="category"
              v-html="prepareMobileMenuDOM(vueHeader.shop.supplements.titleDOM, vueHeader.shop.supplements.entries)"></li>
            <li
              class="category"
              v-html="prepareMobileMenuDOM(vueHeader.shop.sport.titleDOM, vueHeader.shop.sport.entries)"></li>
            <li
              class="category"
              v-html="prepareMobileMenuDOM(vueHeader.shop.samples.titleDOM, vueHeader.shop.samples.entries)"></li>
            <li
              class="category"
              v-html="prepareMobileMenuDOM(vueHeader.shop.offers.titleDOM, vueHeader.shop.offers.entries)"></li>
            <li
              class="category"
              v-html="prepareMobileMenuDOM(vueHeader.shop.coupons.titleDOM, vueHeader.shop.coupons.entries)"></li>
            <li
              class="category"
              v-html="prepareMobileMenuDOM(vueHeader.shop.allProducts.titleDOM, vueHeader.shop.allProducts.entries)"></li>
            <li
              v-if="partnerStatus"
              class="category"
              v-html="prepareMobileMenuDOM(vueHeader.shop.partnerProducts.titleDOM, vueHeader.shop.partnerProducts.entries)"></li>
          </ul>
        </li>
        <li>
          <a
            class="text-transform-uppercase"
            href="#">
            {{ vueHeader.soNewText }}
            <span
              v-if="newNewsAmount > 0 && partnerStatus"
              class="green-dot"></span>
          </a>
          <ul class="vertical menu">
            <li
              class="category"
              v-html="vueHeader.soNew.news.titleDOM"></li>
            <span
              v-if="newNewsAmount > 0 && partnerStatus"
              class="new-news-amount">{{ newNewsAmount }}</span>
            <li
              class="category"
              v-html="vueHeader.soNew.blog.titleDOM"></li>
            <li
              class="category"
              v-html="vueHeader.soNew.media.titleDOM"></li>
          </ul>
        </li>
        <li>
          <a
            class="text-transform-uppercase"
            href="#">{{ vueHeader.corporateText }}</a>
          <ul class="vertical menu">
            <li
              class="category"
              v-html="prepareMobileMenuCorporateDOM(vueHeader.corporate.weAreRingana.titleDOM, vueHeader.corporate.weAreRingana.entries)"></li>
            <li
              class="category"
              v-html="vueHeader.corporate.contact.titleDOM"></li>
            <li
              v-if="currentLanguage === 'de' || currentLanguage === 'en' || !currentLanguage"
              class="category"
              v-html="vueHeader.corporate.jobs.titleDOM"></li>
            <li
              class="category"
              v-html="vueHeader.corporate.press.titleDOM"></li>
            <li
              class="category"
              v-html="prepareMobileMenuDOM(vueHeader.corporate.media.titleDOM, vueHeader.corporate.media.entries)"></li>
            <li
              class="category"
              v-html="prepareMobileMenuDOM(vueHeader.corporate.business.titleDOM, vueHeader.corporate.business.entries)"></li>
            <template v-if="vueHeader.corporate.businessRight.entries.length > 0 && !partnerStatus">
              <li
                v-for="entry of vueHeader.corporate.businessRight.entries"
                :key="entry.linkDOM"
                class="category">
                <a :href="entry.link">{{ entry.linkName }}</a>
              </li>
            </template>

            <template
              v-if="vueHeader.corporate.businessRightPartnersAll.entries.length > 0
                && partnerStatus
                && (currentLanguage && currentLanguage === 'nl')">
              <li
                v-for="entry of vueHeader.corporate.businessRightPartnersAll.entries"
                :key="entry.linkDOM"
                class="category">
                <a :href="entry.link">{{ entry.linkName }}</a>
              </li>
            </template>
            <template
              v-if="vueHeader.corporate.businessRightPartnersAllDe.entries.length > 0
                && partnerStatus
                && (!currentLanguage || currentLanguage !== 'nl')">
              <li
                v-for="entry of vueHeader.corporate.businessRightPartnersAllDe.entries"
                :key="entry.linkDOM"
                class="category">
                <a :href="entry.link">{{ entry.linkName }}</a>
              </li>
            </template>
          </ul>
        </li>
        <li class="category">
          <a :href="`/rethink?lang=${vueHeader.shopLanguageCode}`">
            <span style="background-color: #e6ff00; color: black;">RE*THINK</span>
          </a>
        </li>
        <li>
          <a
            class="text-transform-uppercase"
            href="#">
            {{ currentLanguage }}/<span class="mobile-currency">{{ selectedCurrency }}</span>
          </a>
          <ul class="vertical menu">
            <li class="category">
              <a href="#">{{ vueHeader.languageText }}: {{ currentLanguage }}</a>
              <ul
                id="mobileLanguageSwitch"
                class="vertical menu">
                <template v-for="language in languages">
                  <template v-if="language !== vueHeader.shopLanguageCode">
                    <li
                      :key="language.code"
                      class="category">
                      <a
                        :key="language.code"
                        href="#"
                        @click.prevent.stop="setLanguage(language)">
                        <span>{{ language.code }}</span>
                      </a>
                    </li>
                  </template>
                </template>
              </ul>
            </li>
            <li class="category">
              <a href="#">
                {{ vueHeader.currencyText }}: {{ selectedCurrency }}
              </a>
              <ul
                id="currencySwitchMobile"
                class="vertical menu">
                <li
                  v-for="currency in currencyList"
                  :key="currency.iso"
                  class="subcategory">
                  <span
                    class="mobile-currency-link rin-header__currency"
                    @click.prevent="setSelectedCurrency(currency.iso)">{{ currency.iso }}</span>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="category mobile-menu-left">
          <a :href="vueHeader.myDataLink">
            <div class="mobile-menu-left-icons">
              <img
                :alt="vueHeader.myDataIconAlt"
                :src="icons.humanGrayIcon" />
            </div>
            <div class="mobile-menu-left-link">{{ vueHeader.myAccountText }}</div>
          </a>
        </li>
        <!--<li class="category mobile-menu-left">
          <a href="#">
            <div class="mobile-menu-left-icons">
              <img alt="Dashboard" src="<?php /*echo get_bloginfo('template_directory'); */ ?>/assets/images/dashboard-gray.svg">
            </div>
            <div class="mobile-menu-left-link">Dashboard</div>
          </a>
        </li>-->
        <li class="category mobile-menu-left">
          <a
            href="https://www.instagram.com/ringana/"
            target="_blank">
            <div class="mobile-menu-left-icons">
              <img
                alt="Instagram"
                class="last-one"
                :src="icons.instagramIcon" />
            </div>
            <div class="mobile-menu-left-link">Instagram</div>
          </a>
        </li>
        <li class="category mobile-menu-left">
          <a
            href="https://www.facebook.com/RINGANADE"
            target="_blank">
            <div class="mobile-menu-left-icons">
              <img
                alt="Facebook"
                :src="icons.facebookIcon" />
            </div>
            <div class="mobile-menu-left-link">Facebook</div>
          </a>
        </li>
        <li
          class="category mobile-menu-common is-first"
          v-html="vueHeader.tosDOM"></li>
        <li
          class="category mobile-menu-common"
          v-html="vueHeader.imprintDOM"></li>
        <li
          class="category mobile-menu-common"
          v-html="vueHeader.importantDOM"></li>
        <li
          class="category mobile-menu-common"
          v-html="vueHeader.cancellationDOM"></li>
        <li
          class="category mobile-menu-common"
          v-html="vueHeader.privacyDOM"></li>
        <li
          class="category mobile-menu-common"
          v-html="vueHeader.paymentTypesDOM"></li>
        <li
          class="category mobile-menu-common"
          v-html="vueHeader.shippingDOM"></li>
        <li class="category mobile-menu-common">
          <a href="#">{{ vueHeader.unsubscribeNewsletterText }}</a>
        </li>
        <li
          class="category mobile-menu-common"
          v-html="vueHeader.becomePartnerDOM"></li>
        <li class="category mobile-menu-common">
          <a href="#"><AcceptedCookieRevoke /></a>
        </li>
      </ul>
    </div>
    <Dashboard
      v-if="partnerStatus"
      :show-dashboard="showDashboard"
      @close-dashboard="toggleDashboard()" />
  </header>
</template>

<script>
  import PartnerShopMethods from "../../../methods/PartnerShopMethods";
  import MenuMethods from "../../../methods/MenuMethods";
  import THeaderData from "../../../types/THeaderData";
  import Dashboard from "../../dashboard/Dashboard";
  import icons from "../../../types/TIcons";
  import DomEventHelper from "../../../helpers/DomEventHelper";
  import AcceptedCookieRevoke from '../../acceptedcookierevoke/AcceptedCookieRevoke.vue';

  export default {
    components: { AcceptedCookieRevoke, Dashboard },
    data() {
      return THeaderData; /* not a deep clone - a reference. to we only have to load the data once! */
    },
    computed: {
      partnerDisplayName() {
        if(this.partnerShopInformation) {
          if(this.partnerShopInformation.firstname) {
            return this.partnerShopInformation.firstname;
          }
          if(this.partnerShopInformation.company) {
            return this.partnerShopInformation.company;
          }
        }
        return ``;
      },
    },
    mounted() {
      window.$swal = this.$swal;
    },
    methods: {
      ...MenuMethods,
      ...PartnerShopMethods,
      prepareMobileMenuAcademyDOM(titleDOM, entries) {
        let dom = `<a href="${titleDOM}">Online Academy</a>`;
        if(entries.length > 0) {
          dom += `<ul class="vertical menu">`;
          entries.forEach(entry => {
            if(entry.include && !(entry.classes === `menu-icon-home` || entry.classes === `menu-icon-learning`)) {
              dom += `<li class="subcategory ${entry.classes}"><a href="${entry.link}">${entry.linkName}</a></li>`;
            }
            if(entry.include && entry.classes === `menu-icon-home`) {
              dom += `<li class="subcategory ${entry.classes}"><a href="${entry.link}"><img src="${icons.academyHome}" alt="">${entry.linkName}</a></li>`;
            }
            if(entry.include && entry.classes === `menu-icon-learning`) {
              dom += `<li class="subcategory ${entry.classes}"><a href="${entry.link}"><img src="${icons.academyLearning}" alt="">${entry.linkName}</a></li>`;
            }
          });
          dom += `</ul>`;
        }
        return dom;
      },
      prepareMobileMenuCorporateDOM(titleDOM, entries) {
        let dom = `${titleDOM}`;
        if(entries.length > 0) {
          dom += `<ul class="vertical menu">`;
          dom += `<li class="subcategory"><a href="/corporate/">Why Ringana</a></li>`;
          entries.forEach(entry => {
            if(entry.include) dom += `<li class="subcategory ${entry.classes}"><a href="${entry.link}">${entry.linkName}</a></li>`;
          });
          dom += `</ul>`;
        }
        return dom;
      },
      prepareMobileMenuDOM(titleDOM, entries) {
        let dom = `${titleDOM}`;
        if(entries.length > 0) {
          dom += `<ul class="vertical menu">`;
          entries.forEach(entry => {
            if(entry.include) dom += `<li class="subcategory ${entry.classes}"><a href="${entry.link}">${entry.linkName}</a></li>`;
          });
          dom += `</ul>`;
        }
        return dom;
      },
      toggleSearchbox() {
        DomEventHelper.fireEvent({ name: `rin-searchbox-searchbar-toggled` });
      },
    },
  };
</script>

<style lang="less">
  .rin-header--mobile {
    display: none !important;
  }

  .text-transform-uppercase {
    text-transform: uppercase;
  }

  @media (max-width: 1199px) {
    #menuShopDropdown {
      .subcategory a {
        text-transform: uppercase !important;
      }
    }

    .rin-header {
      &--mobile {
        display: block !important;
      }

      &__currency {
        cursor: pointer;
      }

      .mobile-menu-nav-bar {
        .back,
        img {
          cursor: pointer;
        }
      }

      .logout,
      .mobile-currency-link {
        color: #999;
        cursor: pointer;
        display: block;
        font-size: .85rem;
        letter-spacing: 1.5px;
        line-height: 1.3;
        padding: .7rem 1rem .7rem 1.5rem;
        text-transform: uppercase;
        width: 100%;
      }

      .mobile-currency-link {
        text-transform: none;
      }

      .main-menu .dropdown-pane .category span {
        color: #fff;
        cursor: pointer;
        letter-spacing: 2.5px;
        text-transform: uppercase;
      }

      .menu-icon- {
        &home,
        &learning {
          img {
            height: 18px;
            padding-right: 15px;
          }
        }
      }

      .menu-search {
        &__search-icon {
          cursor: pointer;
          padding: 20px 15px;
        }

        &__image {
          padding: 20px 15px;
        }
      }
    }
  }
</style>
